export const LEGACY_FINIX_FEE_RATE = 0.029;
export const LEGACY_FINIX_FIXED_FEE = 0.31;
export const MIN_TIP_AMOUNT = 1;

export function formatCurrency(amount: number) {
  return `$${amount.toFixed(2)}`;
}

export function parseTipAmount(value: string) {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) && parsed >= MIN_TIP_AMOUNT ? parsed : undefined;
}

export function roundCurrency(amount: number) {
  return Math.round(amount * 100) / 100;
}

export function calculateLegacyFinixFee(amount: number) {
  if (amount <= 0) return 0;
  return roundCurrency((amount + LEGACY_FINIX_FIXED_FEE) / (1 - LEGACY_FINIX_FEE_RATE) - amount);
}

export function calculateLegacyFinixDeductedFee(amount: number) {
  if (amount <= 0) return 0;
  return roundCurrency(amount * LEGACY_FINIX_FEE_RATE + LEGACY_FINIX_FIXED_FEE);
}

export function getFinixBreakdown(amount: number, coverProcessingFee: boolean) {
  const processingFee = coverProcessingFee
    ? calculateLegacyFinixFee(amount)
    : calculateLegacyFinixDeductedFee(amount);
  const total = coverProcessingFee ? roundCurrency(amount + processingFee) : amount;

  return {
    amount,
    processingFee,
    technicianTip: coverProcessingFee ? amount : Math.max(0, roundCurrency(amount - processingFee)),
    total,
  };
}
